module.exports = __webpack_public_path__ + "media/images/check_red-51972a06.png";